module.exports = __webpack_public_path__ + "img/avatar1.58fc3e00.png";